export default {
  imprint: 'Impressum',
  privacy: 'Datenschutz',
};
